import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { Typography } from '@material-ui/core';
import ArrowBackIcon from '../../assets/svg/backArrowWhite.svg';
import './twoSectionContainer.scss';
import { colors, common, textStyles, primaryFont } from '../../assets/theme';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import changePlanIcon from '../../assets/icons/desktop/changeplanicon_desktop.svg';
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';
import detailedPolicy from '../../screens/myAccount/detailedPolicy';
import { isMobile } from 'react-device-detect';

const TwoSectionContainer = (props) => {
    const {
        history: { goBack, go, location },
        getTPL,
    } = props;

    return (
        <Grid container>
            <Grid
                item
                xs={12}
                sm={12}
                md={5}
                className={`left-panel-section ${props.blueSectionStyle}`}
                id="blueSection"
                style={{
                    backgroundColor: props.backgroundColor ? props.backgroundColor : '#1F3563',
                }}
            >
                {props.isDetailed ? (
                    <Grid container xs={12}>
                        <Grid item xs={12} style={{ display: 'inline-block' }}>
                            {props.handleGoBack && props?.renewal !== true && (
                                <Grid item xs={7} style={{ display: 'inline-block' }}>
                                    <img
                                        alt="back"
                                        src={ArrowBackIcon}
                                        className="back-button"
                                        onClick={props.handleGoBack}
                                    />
                                </Grid>
                            )}
                            {props.getTPL !== true && props?.renewal !== true && (
                                <Grid
                                    item
                                    xs={5}
                                    className={classNames(
                                        css(styles.changeplanGrid),
                                        i18n.language === 'ar' ? 'arabic-change-plan' : ''
                                    )}
                                    onClick={props.handleGoBack}
                                    style={{ display: 'inline-block' }}
                                >
                                    {props.changePlanIcon && <img
                                        alt="back"
                                        src={props.changePlanIcon}
                                        className={css(styles.imageStyle)}
                                        style={{ display: 'inline-block' }}
                                    />}


                                    <Typography
                                        style={{ display: 'inline-block' }}
                                        className={css(styles.changeplanStyle)}
                                    >
                                        {props.changePlanText}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="h6"
                                className={classNames(
                                    css(styles.refClass),
                                    css(i18n.language === 'ar' ? styles.arabicSubHeadClass : '')
                                )}
                            >
                                {props.refNumber}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={7} md={12}>
                                    <span>
                                        <Typography
                                            variant="h2"
                                            className={classNames(
                                                css(styles.headingClass),
                                                css(
                                                    i18n.language === 'ar'
                                                        ? styles.arabicHeadingClass
                                                        : ''
                                                )
                                            )}
                                        >
                                            {props.heading}
                                        </Typography>
                                    </span>
                                    {props.subHeading && (
                                        <span>
                                            <Typography
                                                variant="h3"
                                                className={classNames(
                                                    css(styles.subHeadClass),
                                                    css(
                                                        i18n.language === 'ar'
                                                            ? styles.arabicSubHeadClass
                                                            : ''
                                                    )
                                                )}
                                            >
                                                {props.subHeading}
                                            </Typography>
                                        </span>
                                    )}
                                </Grid>

                                <Grid
                                    item
                                    xs={5}
                                    md={12}
                                    className={classNames(
                                        css(styles.gridStyle),
                                        css(i18n.language === 'ar' ? styles.arabicGridStyle : '')
                                    )}
                                >
                                    <span>
                                        <Typography
                                            variant="h3"
                                            className={`${css(styles.yearClass)} ${css(
                                                styles.headingRight
                                            )}`}
                                        >
                                            {props.aedCurrency}{' '}
                                            {props?.renewal && !isMobile
                                                ? ` / ${props.yearLabel}`
                                                : ''}
                                        </Typography>
                                    </span>
                                    <span>
                                        <Typography
                                            variant="h3"
                                            className={classNames(
                                                css(styles.yearClass),
                                                css(
                                                    i18n.language === 'ar'
                                                        ? styles.arabicSubHeadClass
                                                        : ''
                                                )
                                            )}
                                        >
                                            {props?.renewal && !isMobile
                                                ? ''
                                                : `${props.yearLabel}`}
                                        </Typography>
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            {props.vehicleDetails}
                        </Grid>
                    </Grid>
                ) : (
                    <div className="card-container">
                        {props.handleGoBack && (
                            <img
                                alt="back"
                                src={ArrowBackIcon}
                                className="back-button"
                                onClick={props.handleGoBack}
                            />
                        )}
                        {props.detailedPolicy && (
                            <Grid container className={css(styles.detailedPolicyContainer)}>
                                <Grid item xs={12} className={css(styles.vehicleName)}>
                                    {props.detailedPolicyObj.vehicleName}
                                </Grid>
                                <Grid item xs={12} className={css(styles.lightGreyText)}>
                                    {props.detailedPolicyObj.yearMakeModel}
                                </Grid>
                                <Grid item xs={12} className={css(styles.policyNo)}>
                                    {i18n.t('twoSectionContainer.policyNo')}.{' '}
                                    {props.detailedPolicyObj.policyNo}
                                </Grid>
                                <Grid item xs={12}
                                className={classNames(
                                    css(styles.lightGreyText),
                                    i18n.language === 'ar' ? 'phone-number-arabic' : ''
                                )}>
                                    {props.detailedPolicyObj.startDate} -{' '}
                                    {props.detailedPolicyObj.endDate}
                                </Grid>
                                <Grid item xs={12} className={css(styles.amountSection)}>
                                    <Grid container>
                                        <Grid
                                            item
                                            xs={6}
                                            style={{ padding: 8 }}
                                            className={
                                                i18n.language === 'ar'
                                                    ? css(styles.borderLeft)
                                                    : css(styles.borderRight)
                                            }
                                        >
                                            <Grid container>
                                                <Grid item xs={12} className={css(styles.amount)}>
                                                    {props.detailedPolicyObj.currency}{' '}
                                                    {props.detailedPolicyObj.annualPremium}
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    className={css(styles.amountSub)}
                                                >
                                                    {i18n.t('twoSectionContainer.annualPremium')}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={6} style={{ padding: 8 }}>
                                            <Grid container>
                                                <Grid item xs={12} className={css(styles.amount)}>
                                                    {props.detailedPolicyObj.currency}{' '}
                                                    {props.detailedPolicyObj.sumInsured}
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    className={css(styles.amountSub)}
                                                >
                                                    {i18n.t('twoSectionContainer.sumInsured')}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        {props.heading && (
                            <Typography
                                variant="h2"
                                className={classNames(
                                    css(styles.heading, props.headingStyle),
                                    i18n.language === 'ar' ? 'arabicHeadingClass' : ''
                                )}
                            >
                                {props.heading}
                                <br />
                                {props.heading2}
                            </Typography>
                        )}
                        {(props.subHeading || props.subHeading1) && (
                            <Typography
                                variant="h4"
                                className={classNames(
                                    css(styles.subHeading, props.subHeadingStyle),
                                    i18n.language === 'ar' ? 'arabic-plain' : ''
                                )}
                            >
                                {props.subHeading}
                                <br />
                                {props.subHeading1}
                            </Typography>
                        )}
                        {props.src && (
                            <img
                                className={`image-position ${props.imageClassName}`}
                                src={props.src}
                                alt={props.alt}
                            />
                        )}
                        <div className="button-section">{props.showButton}</div>
                    </div>
                )}
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
                md={7}
                className={classNames(props.rightPanelClassName, 'form-container')}
            >
                {props.children}
            </Grid>
        </Grid>
    );
};
const styles = StyleSheet.create({
    detailedPolicyContainer: {
        textAlign: 'center',
        marginTop: 20,
        marginBottom: 50,
        paddingRight: 25,
        [common.mediaQuery.minMd]: {
            marginTop: '26%',
        },
        [common.mediaQuery.minXlg]: {
            marginTop: '40% !important',
        },
    },
    vehicleName: {
        ...primaryFont.medium,
        fontSize: 22,
        lineHeight: '18px',
        color: colors.lightWhite,
        [common.mediaQuery.minMd]: {
            fontSize: 30,
            lineHeight: '20px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '45px !important',
            lineHeight: '30px !important',
        },
    },
    lightGreyText: {
        paddingTop: 12,
        ...primaryFont.book,
        fontSize: 18,
        lineHeight: '18px',
        color: colors.grey[150],
        [common.mediaQuery.minMd]: {
            fontSize: 16,
            lineHeight: '20px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '24px !important',
            lineHeight: '30px !important',
        },
    },
    borderRight: {
        borderRight: '1px solid #051330',
    },
    borderLeft: {
        borderLeft: '1px solid #051330',
    },
    policyNo: {
        paddingTop: 12,
        ...primaryFont.book,
        fontSize: 16,
        lineHeight: '18px',
        color: colors.lightWhite,
        [common.mediaQuery.minMd]: {
            fontSize: 16,
            lineHeight: '20px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '24px !important',
            lineHeight: '30px !important',
        },
    },
    amountSection: {
        paddingTop: 14,
        [common.mediaQuery.minSm]: {
            paddingTop: '8%',
        },
    },
    amount: {
        ...primaryFont.bold,
        fontSize: 16,
        lineHeight: '16px',
        color: colors.lightWhite,
        [common.mediaQuery.minXlg]: {
            fontSize: 24,
            lineHeight: '26px',
        },
    },
    amountSub: {
        ...primaryFont.book,
        fontSize: 12,
        lineHeight: '18px',
        color: colors.lightWhite,
        [common.mediaQuery.minXlg]: {
            fontSize: 18,
            lineHeight: '30px',
        },
    },
    heading: {
        color: colors.white,
        paddingBottom: 5,
        ...primaryFont.medium,
        paddingRight: 90,
        fontSize: 22,
        [common.mediaQuery.minMd]: {
            fontSize: 28,
            paddingBottom: 15,
            paddingRight: 0,
            paddingTop: '28px !important',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: 45,
            paddingBottom: 15,
            paddingRight: 0,
            lineHeight: '53px !important',
        },
    },
    arabicHeadingClass: {
        paddingRight: '0px !important',
        ...primaryFont.normalArabic,
    },
    subHeading: {
        color: colors.grey[450],
        paddingBottom: 8,
        lineHeight: '18px',
        fontSize: 14,
        ...primaryFont.book,
        [common.mediaQuery.minMd]: {
            lineHeight: '22px',
            fontSize: 16,
            paddingRight: 0,
        },
        [common.mediaQuery.minXlg]: {
            lineHeight: '32px',
            fontSize: 24,
            paddingRight: 0,
            width: 414,
        },
    },

    containerClass: {
        marginTop: '30px',
    },

    headingClass: {
        color: colors.white,
        marginBottom: 15,
        fontFamily: 'Circular Std Medium',
        ...textStyles.h1,
        [common.mediaQuery.minLg]: {},
    },
    headingRight: {
        '@media (max-width: 959px)': {
            textAlign: 'right',
        },
    },
    subHeadClass: {
        fontFamily: `${'Circular Std Book'} !important`,
        color: colors.grey[450],
        fontSize: 22,
        linHeight: '26px',
        paddingBottom: 47,
        [common.mediaQuery.minMd]: {
            lineHeight: '30px',
            fontSize: 20,
            paddingBottom: 26,
        },
        [common.mediaQuery.minXlg]: {
            lineHeight: '53px !important',
            fontSize: '45px !important',
            paddingBottom: '39px !important',
        },
    },
    refClass: {
        color: colors.grey[450],
        fontSize: '12px',
        fontFamily: 'Circular Std Book',
        paddingTop: 15,
        paddingBottom: 5,
        [common.mediaQuery.minMd]: {
            fontSize: '16px',
            lineHeight: '12px',
            marginBottom: '10px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '24px !important',
            lineHeight: '18px !important',
            paddingTop: '23px !important',
            marginBottom: '10px',
        },
    },
    aedCurrencyClass: {
        color: colors.white,
        paddingBottom: 5,
        fontSize: '22px',
        ...textStyles.extraLarge,
        [common.mediaQuery.minLg]: {
            paddingTop: 28,
        },
    },
    yearClass: {
        color: colors.white,
        fontFamily: 'Circular Std Medium',
        fontSize: 22,
        marginTop: '10px',
        [common.mediaQuery.minMd]: {
            lineHeight: '30px',
            fontSize: 24,
        },
        [common.mediaQuery.minXlg]: {
            lineHeight: '53px !important',
            fontSize: '36px !important',
            marginTop: '-15px',
        },
        '@media (max-width: 959px)': {
            float: 'right',
        },
        verticalAlign: 'super',
    },
    gridStyle: {
        [common.mediaQuery.minSm]: {
            fontSize: '24px',
            textAlign: 'left',
        },
    },
    arabicGridStyle: {
        [common.mediaQuery.minSm]: {
            fontSize: '24px',
            textAlign: 'right',
        },
    },
    changeplanStyle: {
        ...primaryFont.book,
        fontSize: '12px',
        color: colors.grey[150],
        paddingLeft: 7,
        verticalAlign: 'top',
        [common.mediaQuery.minMd]: {
            fontSize: 12,
            textAlign: 'left',
            lineHeight: '16px',
        },
        [common.mediaQuery.minXlg]: {
            fontSize: '18px !important',
            lineHeight: '26px !important',
        },
    },
    changeplanGrid: {
        cursor: 'pointer',
        float: 'right',
        [common.mediaQuery.minXlg]: {
            paddingRight: 19,
        },
    },
    imageStyle: {
        width: '9px',
        height: '9px',
        [common.mediaQuery.minMd]: {
            width: '14px !important',
            height: '14px !important',
        },
        [common.mediaQuery.minXlg]: {
            paddingTop: '5px !important',
        },
    },
    arabicSubHeadClass: {
        ...primaryFont.normalArabic,
    },
});

TwoSectionContainer.propTypes = {
    handleGoBack: PropTypes.func.isRequired,
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string.isRequired,
    subHeading1: PropTypes.string.isRequired,
    showButton: PropTypes.func.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    history: PropTypes.shape({
        goBack: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default withTranslation()(TwoSectionContainer);
